/*
Controller: InventoryIngestionBinaries

Operations:
  createPresignedUrl
  getIngestionBinaries
  uploadBinary
  deleteBinaries
*/
var Api = require('../config')
var CreatePresignedUrlRequestDef = require('../definitions/CreatePresignedUrlRequest')
var CreateBinaryRequestDef = require('../definitions/CreateBinaryRequest')
var BinariesDeleteRequestDef = require('../definitions/BinariesDeleteRequest')

var InventoryIngestionBinaries = (function () {
  /*
  Operation: createPresignedUrl
  This accepts multiple MD5s in the request and returns presigned URLs for uploading the files for inventory ingestion.
  Parameters:
    inventoryIngestionId: Id of the inventory ingestion

  Responses:
    HTTP 200: Presigned URL for the provided MD5
    HTTP 400: md5 not valid.
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
  */
  function createPresignedUrlInventoryIngestionBinaries (inventoryIngestionId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!inventoryIngestionId) {
          throw new Error('inventoryIngestionId: Missing parameter')
        }
        if (inventoryIngestionId && !(typeof inventoryIngestionId === 'string')) {
          throw new Error('inventoryIngestionId: Wrong type: Got "' + (typeof inventoryIngestionId) + '", but expected: "string"')
        }
        CreatePresignedUrlRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/inventoryIngestion/{inventoryIngestionId}/binaries/createPresignedUrl'
      path = path.replace('{' + 'inventoryIngestionId' + '}', inventoryIngestionId)
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getIngestionBinaries
  Get all binaries metadata
  Parameters:
    inventoryIngestionId: Id of the inventory ingestion
  Responses:
    HTTP 200: Collection of Binaries of this inventory ingestion
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 404: inventory ingestion not found
  */
  function getIngestionBinariesInventoryIngestionBinaries (inventoryIngestionId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!inventoryIngestionId) {
          throw new Error('inventoryIngestionId: Missing parameter')
        }
        if (inventoryIngestionId && !(typeof inventoryIngestionId === 'string')) {
          throw new Error('inventoryIngestionId: Wrong type: Got "' + (typeof inventoryIngestionId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/inventoryIngestion/{inventoryIngestionId}/binaries'
      path = path.replace('{' + 'inventoryIngestionId' + '}', inventoryIngestionId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: uploadBinary
  Upload font binaries
  Parameters:
    inventoryIngestionId: Id of the inventory ingestion

  Responses:
    HTTP 200: Successful upload
    HTTP 400: Upload failed. This could be due to file format issues, file size etc.
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
  */
  function uploadBinaryInventoryIngestionBinaries (inventoryIngestionId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!inventoryIngestionId) {
          throw new Error('inventoryIngestionId: Missing parameter')
        }
        if (inventoryIngestionId && !(typeof inventoryIngestionId === 'string')) {
          throw new Error('inventoryIngestionId: Wrong type: Got "' + (typeof inventoryIngestionId) + '", but expected: "string"')
        }
        CreateBinaryRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/inventoryIngestion/{inventoryIngestionId}/binaries'
      path = path.replace('{' + 'inventoryIngestionId' + '}', inventoryIngestionId)
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: deleteBinaries
  Delete inventory ingestion binaries
  Parameters:
    inventoryIngestionId: Id of the inventory ingestion

  Responses:
    HTTP 200: Successful delete
    HTTP 400: Failed to delete binary
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 404: Binary not found
  */
  function deleteBinariesInventoryIngestionBinaries (inventoryIngestionId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!inventoryIngestionId) {
          throw new Error('inventoryIngestionId: Missing parameter')
        }
        if (inventoryIngestionId && !(typeof inventoryIngestionId === 'string')) {
          throw new Error('inventoryIngestionId: Wrong type: Got "' + (typeof inventoryIngestionId) + '", but expected: "string"')
        }
        BinariesDeleteRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/inventoryIngestion/{inventoryIngestionId}/binaries/delete'
      path = path.replace('{' + 'inventoryIngestionId' + '}', inventoryIngestionId)
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['createPresignedUrl'] = createPresignedUrlInventoryIngestionBinaries
  ret['getIngestionBinaries'] = getIngestionBinariesInventoryIngestionBinaries
  ret['uploadBinary'] = uploadBinaryInventoryIngestionBinaries
  ret['deleteBinaries'] = deleteBinariesInventoryIngestionBinaries
  return ret
})()

module.exports = InventoryIngestionBinaries
